(ns app.front.view.admin.export-import
  (:require [ajax.core :refer [POST]]
            [app.domain.attachment.model :as attachment-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.view.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::reset
  (fn [{:keys [db]} _]
    {:db           (-> db
                       (assoc ::export-group nil)
                       (assoc ::import-group nil)
                       (assoc ::import-file nil))
     :comm/command {:command    :admin/get-authority-groups
                    :method     :get
                    :on-success [::customers-response]}}))

(rf/reg-event-db ::set-export-group
  (fn [db [_ group-id]]
    (assoc db ::export-group group-id)))

(rf/reg-event-db ::set-import-group
  (fn [db [_ group-id]]
    (-> db
        (assoc ::import-group group-id)
        (assoc ::import-file nil))))

(rf/reg-event-db ::set-import-file
  (fn [db [_ file]]
    (assoc db ::import-file file)))

(rf/reg-event-db ::reset-import-options
  (fn [db _]
    (-> db
        (assoc ::import-group nil)
        (assoc ::import-file nil))))

(rf/reg-event-fx ::import-config.success
  (fn [_ [_ {:keys [removed-entities warnings] :as response}]]
    (let [missing-files   (get warnings :missing-selected-files 0)
          missing-sources (get warnings :rules-with-missing-sources 0)
          notification    (if (or (pos? missing-files) (pos? missing-sources))
                            [:notifications/add :toast :warning :warning/warning
                             [[:admin/import-success-with-warnings] [missing-files missing-sources]]]
                            [:notifications/add :toast :success :success
                             (if (ff/enabled? :feature-flag.id/ai-config-transfer)
                               :admin/import-success-ai
                               :admin/import-success)])]
      {:fx (concat
             (when (seq removed-entities)
               [[:dispatch [::entities/remove-from-entity-db 200 response]]])
             [[:dispatch [::reset-import-options]]
              [:dispatch notification]])})))

(rf/reg-event-fx ::import-config.error
  (fn [_ [_ response]]
    {:fx [[:dispatch [:notifications/add :toast :error :failure
                      (or (-> response :response :error) :admin/import-failure)]]]}))

(rf/reg-event-fx ::import-config
  (fn [_ [_ group-id file]]
    (POST (str "/api/command/admin/import-group-config?group-id=" group-id)
      {:headers         {"Content-Type" attachment-model/zip-content-type}
       :response-format :transit
       :body            file
       :handler         #(>evt [::import-config.success %])
       :error-handler   #(>evt [::import-config.error %])})
    {}))

(rf/reg-event-db ::customers-response
  (fn [db [_ _ data]]
    (assoc db ::customers data)))

(rf/reg-sub ::customers (p/fn->> ::customers (sort-by first)))
(rf/reg-sub ::export-group :-> ::export-group)
(rf/reg-sub ::import-group :-> ::import-group)
(rf/reg-sub ::import-file :-> ::import-file)

(defn view [_]
  (let [tr           (<sub [:tr])
        export-group (<sub [::export-group])
        import-group (<sub [::import-group])
        import-file  (<sub [::import-file])
        import-guide (tr [(if (ff/enabled? :feature-flag.id/ai-config-transfer)
                            :admin/import-guide-ai-merge
                            :admin/import-guide)])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading
      [:h1.bx--col-xs-12 (tr [:view/admin.export-import])]]
     [section/section
      "config-export"
      {:tr tr}
      (tr [:export])
      [:div.flex.items-end.gap-4
       [:div.w-1-2.xxl:w-2-5
        [acommon/group-selector {:id        "export-group-selector"
                                 :tr        tr
                                 :on-change #(>evt [::set-export-group (:group-id %)])}]]
       [:div
        (cc/button {:kind             :primary
                    :icon             i/download
                    :icon-description (tr [:export])
                    :disabled         (nil? export-group)
                    :href             (str "/api/command/admin/export-group-config?group-id=" export-group)}
                   (tr [:export]))]]]
     [section/section
      "config-import"
      {:tr tr}
      (tr [:import])
      [:div.mb-3 import-guide]
      [:div.flex.items-end.gap-4
       [:div.w-1-2.xxl:w-2-5
        [acommon/group-selector {:id        "import-group-selector"
                                 :tr        tr
                                 :on-change (fn [group]
                                              (>evt [::set-import-group (:group-id group)]))}]]
       [:div
        (cc/file-uploader-button {:accept     [".gc"]
                                  :key        (str "import-config-" import-group)
                                  :label-text (tr [:admin/add-file])
                                  :on-change  #(>evt [::set-import-file (-> % .-target .-files array-seq first)])})]
       [:div
        [ui/modal-confirmation-button {:tr                  tr
                                       :id                  "import"
                                       :trigger-button-text (tr [:import])
                                       :on-yes-click        (fn [_]
                                                              (>evt [::import-config import-group import-file]))
                                       :trigger-button-opts {:kind             :danger
                                                             :icon             i/upload
                                                             :icon-description (tr [:import])
                                                             :disabled         (or (nil? import-group)
                                                                                   (nil? import-file))}}
         [:div import-guide]]]]]]))

(def route
  {:name        :view/admin.export-import
   :view        view
   :controllers [{:start (fn [] (>evt [::reset]))}]})
